export default __webpack_public_path__ + "static/media/cubiertos.6ad3a90c.png";